module.exports = __webpack_public_path__ + "static/img/2.9513113.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/eng/2.png
// module id = 28RB
// module chunks = 0